<template>
  <div>
    <!--滑动15秒才能关闭弹窗-->
    <van-dialog v-model="visible" :showConfirmButton="false" class="custormTips4">
      <p class="title">温馨提示</p>
      <div class="t-content">
        自即日起，通过平台结算，需完成人脸识别认证，未完成则无法完成账户收款，请立即完成认证
      </div>
      <div class="t-btns-box">
        <div @click="handleClose">
          去认证
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import config from '@/configs/config'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      require: true
    }
  },
  data() {
    return {}
  },
  watch: {},
  mounted() {},

  methods: {
    // 处理关闭操作
    handleClose() {
      this.addUserNotice(3)
      this.$emit('close')
      location.href =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx73576c3cf6b396f8&redirect_uri=http%3A%2F%2Fconfirm.serviceshare.com%2Fpages%2FYoufuSupport.html%23%2Funified-login?appKey=wx73576c3cf6b396f8&response_type=code&scope=snsapi_base&state=1767496543936305#wechat_redirect'
    },
    async getUserInfo() {
      // 身份信息
      const res = await tuhu.fetch(`${config.apis.GET_USERINFO}`)
      if (res && res.code === '200') {
        const userInfoPromise = tuhu._setUserInfo(res.data) // 返回数据
        if (this.options && this.options.resolve) {
          this.options.resolve(userInfoPromise)
        }
      } else {
        tuhu.toast(res.message || '获取权限信息失败')
      }
    },
    //用户看过某个公告
    async addUserNotice(type) {
      try {
        let formdata = new FormData()
        formdata.append('type', type) // 文件对象
        const data = await tuhu.fetch(`${config.apis.ADD_USER_NOTICE}`, {
          method: 'post',
          body: new URLSearchParams({
            type: type
          }),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        if (data.code === '200') {
          await this.getUserInfo()
        } else {
          tuhu.toast(data.message)
        }
      } catch (error) {
        console.log('err', error)
        tuhu.toast(error)
      }
    }
  }
}
</script>

<style scoped lang="less">
.custormTips4 {
  width: 16rem;
  height: 12rem;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  .title {
    height: 2rem;
    text-align: center;
    line-height: 2rem;
    font-size: 1.2rem;
    font-weight: 500;
    color: #ff0000;
    margin-top: 0.6rem;
  }

  .t-content {
    height: 6rem;
    padding: 1rem;
    text-align: center;
    font-size: 0.8rem;
    line-height: 1.2rem;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #333333;
  }
  .t-btns-box {
    width: 16rem;
    height: 3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.5rem;
    div {
      font-size: 0.8rem;
      width: 10rem;
      height: 2.2rem;
      border-radius: 1rem;
      display: flex;
      flex-direction: column;
      color: white;
      align-items: center;
      justify-content: center;
      background-color: #409eff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/sildePopup3.vue